import * as React from "react";
import { WorkloadCreateForm } from "./form";

export const WorkloadCreateInitializer: React.FC = () => {
  return <WorkloadCreateForm />;
};
